export default "__VITE_PUBLIC_ASSET__8cad72d4__"